import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Seo from "../components/Seo";
import { LoadingState } from "../components/StateBlocks";
import api, { ApiError } from "../utils/api";

export default function RsvpVerify() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | confirmed | waitlisted | error
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setErrorMessage("This link is missing a verification token.");
      return;
    }

    // Immediately exchange the raw token and remove it from the URL/history
    // so it is never bookmarked, shared, or left in browser history.
    window.history.replaceState({}, "", "/rsvp/verify");

    api
      .verifyRsvp(token)
      .then((data) => {
        setStatus(data.status === "CONFIRMED" ? "confirmed" : "waitlisted");
      })
      .catch((err) => {
        setStatus("error");
        setErrorMessage(err instanceof ApiError ? err.message : "This link is invalid or has expired.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Seo title="Confirm RSVP" description="Confirm your RSVP for an HS Library Hangout event." />
      <h1>Confirm your RSVP</h1>
      {status === "loading" && <LoadingState label="Confirming your RSVP\u2026" />}
      {status === "confirmed" && (
        <div className="alert alert-success" role="status">
          <p>You&rsquo;re confirmed! We&rsquo;ve sent a confirmation email with a link to manage your RSVP.</p>
          <Link to="/events">Browse more events</Link>
        </div>
      )}
      {status === "waitlisted" && (
        <div className="alert alert-warning" role="status">
          <p>
            This event is full, so you&rsquo;ve been added to the waitlist. We&rsquo;ll email you if a spot
            opens up.
          </p>
          <Link to="/events">Browse more events</Link>
        </div>
      )}
      {status === "error" && (
        <div className="alert alert-error" role="alert">
          <p>{errorMessage}</p>
          <Link to="/contact">Contact us for help</Link>
        </div>
      )}
    </>
  );
}
